"use strict";

var getValueOfKeyMatching = require('../getValueOfKeyMatching');

function BasicBookletWeddingPrograms(params) {
  var quantity = getValueOfKeyMatching(params, /multi_quantity/);
  var product_size = getValueOfKeyMatching(params, /program_size/);
  var acc_ribbon = getValueOfKeyMatching(params, /acc_ribbon/);
  this.personalization.push({
    name: 'Names, Date, Location',
    value: params.pers_programFrontPanel
  });
  this.personalization.push({
    name: 'Wedding Party',
    value: params.pers_programMiddlePanel
  });
  this.personalization.push({
    name: 'Ceremony',
    value: params.pers_programThirdPanel
  });
  this.personalization.push({
    name: 'Additional Wording',
    value: params.pers_programWording
  });
  this.basicPrograms.add({
    quantity: quantity,
    product_size: product_size,
    acc_ribbon: acc_ribbon
  });
}

module.exports = BasicBookletWeddingPrograms;